// Onboarding step 1 (docs/06 §2): app identity + the two entry paths. No
// forms, no email — the button choice is the entire decision the user makes.

import type { ReactNode } from 'react';
import { useT } from '../../i18n/index.js';

export function Welcome({
  onCreateAccount,
  onRestoreAccount,
  onRestorePasskey,
}: {
  onCreateAccount: () => void;
  onRestoreAccount: () => void;
  /** Offered only where a WebAuthn platform exists (feature-detected). */
  onRestorePasskey?: () => void;
}): ReactNode {
  const t = useT();
  return (
    <main className="mx-auto flex min-h-full w-full max-w-app flex-col justify-center gap-10 p-6">
      <div className="flex flex-col items-center gap-3 text-center">
        <h1 className="text-3xl font-semibold tracking-wide text-ink">Merkury</h1>
        <p className="text-muted">{t('welcome.tagline')}</p>
      </div>
      <div className="flex flex-col gap-3">
        <button
          type="button"
          onClick={onCreateAccount}
          className="min-h-touch rounded-xl bg-accent px-4 font-medium text-ink active:bg-accent-press"
        >
          {t('welcome.create')}
        </button>
        <button
          type="button"
          onClick={onRestoreAccount}
          className="min-h-touch rounded-xl border border-edge bg-surface px-4 font-medium text-ink"
        >
          {t('welcome.haveAccount')}
        </button>
        {onRestorePasskey && (
          <button
            type="button"
            onClick={onRestorePasskey}
            className="min-h-touch rounded-xl px-4 text-sm font-medium text-accent active:opacity-70"
          >
            {t('welcome.restorePasskey')}
          </button>
        )}
      </div>
    </main>
  );
}
